module.exports = __webpack_public_path__ + "img/bombinha.bd62230f.png";